import React, { useContext, useState } from "react";
import Contexto from "../context/Contexto";
import "../assets/css/Login.css";
const Regalo = () => {
  const { canjearCursos, mandarMensajes } = useContext(Contexto);
  const [codiguito, setCodiguito] = useState("");
  const handleCodigo = (e) => {
    setCodiguito(e.target.value);
  };

  const handleCambio = (e) => {
    if (codiguito != "") {
      canjearCursos(codiguito);
    } else {
      mandarMensajes("No te olvides de escribir el código");
    }
  };
  return (
    <React.Fragment>
      <div className="soporteLogin">
        <div className="login">
          <div className="login__wrapper">
            <h2 className="titFelicitaciones">Felicitaciones!</h2>{" "}
            <input
              type="text"
              className="formuCC"
              name="codigo"
              onChange={handleCodigo}
              placeholder="Ingresá tu código"
            />
            <button
              id="registro"
              className="formuBT"
              name="acceder"
              onClick={handleCambio}
            >
              Canjear
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Regalo;
